<div class="form-group">
  @if ( question?.email_version || labelText) {
    <label [innerHTML]="question?.email_version ? question?.email_version :labelText"></label>
  }
  @if (showNoteText) {
    <div class="note note--sm note--info mt-15 mb-15">
      <div class="note__icon">
        <svg class="icon">
          <use xlink:href="#info-small"></use>
        </svg>
      </div>
      @if (showNoteText) {
        <div class="note__content">
          <p [innerHTML]="noteText"></p>
        </div>
      }
    </div>
  }
  @if (showUploadLabelText) {
    <div class="custom-upload__label">
      <small [innerHTML]="uploadLabelText"></small>
    </div>
  }
  <div class="custom-upload dz-clickable custom-upload--media" [id]="fileSelectorEl">
    <div class="custom-upload__dropzone dz-default">
      <div class="custom-upload__thumb">
        <img src="assets/img/upload-selfie.svg">
      </div>
      <div class="custom-upload__instructions">
        <p>Tap to add files</p>
        <svg class="icon">
          <use xlink:href="#upload"></use>
        </svg>
        <p>Drag & drop files here or <strong>browse</strong>
      </p>
    </div>
  </div>
</div>
</div>
